// extracted by mini-css-extract-plugin
export default {"customDot":"CustomDot_customDot__nrH0e","active":"CustomDot_active__xIh6r","inactive":"CustomDot_inactive__uzVoz"};